import { type Lang, COPY, renderEm } from "../copy.js";
import { SectionEyebrow } from "./SectionEyebrow.js";

export function EveningBlock({ lang }: { lang: Lang }) {
  const t = COPY[lang];
  return (
    <section className="block">
      <div className="wrap">
        <SectionEyebrow num={t.evening.eyebrow.num} name={t.evening.eyebrow.name} />
        <h2 className="hd">{renderEm(t.evening.h)}</h2>
        <p className="lead">{t.evening.lead}</p>
        <ul className="evening-list">
          {t.evening.list.map((it, i) => (
            <li key={i}>
              <span className="ico">{it.ico}</span>
              <div>
                <span className="what">{it.what}</span>
                <span className="how">{renderEm(it.how)}</span>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
